import React from 'react';

import './styles.scss';

import LayoutWrapper from "./components/LayoutWrapper";
import {FormWrapper, SubmitBtnMerchant} from "../../../helpers/FormHandlers";
import {MerchantRequestError} from "../../../helpers/InputsHelpers";

export const LayoutAuthWithForm = ({
 title,
 description,
 content,
 beforeFooter,
 submitBtnText,
 preFooterFormElement,
 additional,
 formProps,
 ...rest
}) => {
  return (
    <LayoutWrapper
      {...rest}
    >
      <FormWrapper
        {...formProps}
      >{(formCtx) => (
        <>
          <h2 className="auth-content__title">
            {title}
          </h2>
          <div className="auth-content__short-desc">
            {description}
            <MerchantRequestError formCtx={formCtx} />
          </div>
          <div className="auth-content__inputs">
            {content(formCtx)}
          </div>
          <div className="auth-content__pre-footer">
            {beforeFooter}
            {preFooterFormElement && preFooterFormElement(formCtx)}
          </div>
          <div className="auth-content__footer">
            <div className="auth-content__submit-btn">
              <SubmitBtnMerchant formCtx={formCtx}>
                {submitBtnText || 'Submit'}
              </SubmitBtnMerchant>
            </div>
            {additional && (
              <div className="auth-content__footer-additional">
                {additional}
              </div>
            )}
          </div>
        </>
      )}</FormWrapper>
    </LayoutWrapper>
  )
}

export const LayoutAuthWithDesc = ({description, beforeFooter, title, control, additional, ...rest}) => {
  return (
    <LayoutWrapper
      {...rest}
    >
      <div className="auth-content__title-block">
        <h2 className="auth-content__title">
          {title}
        </h2>
      </div>
      <div className="auth-content__desc">
        {description}
      </div>
      <div className="auth-content__footer">
        {control}
        {additional && (
          <div className="auth-content__footer-additional">
            {additional}
          </div>
        )}
      </div>
    </LayoutWrapper>
  )
}
